export var EngagementStatus;
(function (EngagementStatus) {
    EngagementStatus["ACTIVE"] = "ACTIVE";
    EngagementStatus["PASSIVE"] = "PASSIVE";
    EngagementStatus["TERMINATED"] = "TERMINATED";
    EngagementStatus["UNASSIGNED"] = "UNASSIGNED";
})(EngagementStatus || (EngagementStatus = {}));
